export const BudgetOptions = {
  Personnel: {
    title: "Personnel",
    subCategory: [
      "Researcher Salary",
      "Research Assistant Salary",
      "Fringe Benefits",
    ],
  },
  Equipment: {
    subCategory: [
      "Computers/Software",
      "Laboratory Equipment",
      "Other Equipment (Specify)",
    ],
  },
  Travel: {
    subCategory: ["Domestic Travel", "International Travel"],
  },
  Supplies: {
    subCategory: [
      "Office Supplies",
      "Laboratory Supplies",
      "Participant Compensation",
    ],
  },
  "Publication Costs": {
    subCategory: [
      "Article Processing Charges (APCs)",
      "Open Access Fees",
      "Proofreading and Editing Fees",
    ],
  },
  "Other Expenses": {
    subCategory: [""],
  },
};

export const CrowdfundingDurationOptions = [
  { unit: "day", value: 3 },
  { unit: "day", value: 7 },
  { unit: "day", value: 14 },
  { unit: "day", value: 30 },
  { unit: "day", value: 60 },
  { unit: "day", value: 90 },
];
